<template>
  <div>
    <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
        <div class="page_nav">
          <ul>
            <li>
              <router-link to="/main" @click.native="$store.commit('setActive', '')">{{
                $t("common.home")
              }}</router-link>
            </li>
            <li>
              <a href="#">{{ $t("common.myLibrary") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/mylibrary/bookmarks')">
              <a href="#">{{ $t("mylibrary.mylibrary.bookmarks") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/mylibrary/myqna')">
              <a href="#">{{ $t("mylibrary.mylibrary.myqna") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/mylibrary/feedback')">
              <a href="#">{{ $t("mylibrary.mylibrary.feedback") }}</a>
            </li>
            <li v-if="this.$route.path.includes('/mylibrary/myinfo')">
              <a href="#">{{ $t("mylibrary.mylibrary.myinfo") }}</a>
            </li>
          </ul>
        </div>
        <h2>{{ $t("common.myLibrary") }}</h2>
      </div>
    </div>
    <section class="sub_contents_wrap container">
      <div class="stu_tab">
        <ul class="view_web">
          <li>
            <router-link
              @click.native="[loadComponent('Bookmarks'), changeNav('Bookmarks')]"
              ref="Bookmarks"
              :class="this.$route.path.includes('/mylibrary/bookmarks') ? 'on' : ''"
              to="/mylibrary/bookmarks"
              >{{ $t("mylibrary.mylibrary.bookmarks") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('My Q&A'), changeNav('My Q&A')]"
              ref="My Q&A"
              :class="this.$route.path.includes('/mylibrary/myqna') ? 'on' : ''"
              to="/mylibrary/myqna"
              >{{ $t("mylibrary.mylibrary.myqna") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('Feedback'), changeNav('Feedback')]"
              ref="FeedBack"
              :class="this.$route.path.includes('/mylibrary/feedback') ? 'on' : ''"
              to="/mylibrary/feedback"
              >{{ $t("mylibrary.mylibrary.feedback") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('My Info'), changeNav('My Info')]"
              ref="MyInfo"
              :class="this.$route.path.includes('/mylibrary/myinfo') ? 'on' : ''"
              to="/mylibrary/myinfo"
              >{{ $t("mylibrary.mylibrary.myinfo") }}</router-link
            >
          </li>
        </ul>
        <div class="subtab_drop dropdown">
          <button
            class="btn btn-secondary dropdown-toggle"
            type="button"
            id="subTabdropdown01"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ nav }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="subTabdropdown01">
            <li>
              <router-link
                to="/mylibrary/bookmarks"
                @click.native="[loadComponent('Bookmarks'), changeNav('Bookmarks')]"
                ref="Bookmarks"
                class="dropdown-item"
                :class="this.$route.path.includes('/mylibrary/bookmarks') ? 'on' : ''"
                >{{ $t("mylibrary.mylibrary.bookmarks") }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/mylibrary/myqna"
                @click.native="[loadComponent('My Q&A'), changeNav('My Q&A')]"
                ref="My Q&A"
                class="dropdown-item"
                :class="this.$route.path.includes('/mylibrary/myqna') ? 'on' : ''"
                >{{ $t("mylibrary.mylibrary.myqna") }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/mylibrary/feedback"
                @click.native="[loadComponent('Feedback'), changeNav('Feedback')]"
                ref="FeedBack"
                class="dropdown-item"
                :class="this.$route.path.includes('/mylibrary/feedback') ? 'on' : ''"
                >{{ $t("mylibrary.mylibrary.feedback") }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/mylibrary/myinfo"
                @click.native="[loadComponent('My Info'), changeNav('My Info')]"
                ref="MyInfo"
                class="dropdown-item"
                :class="this.$route.path.includes('/mylibrary/myinfo') ? 'on' : ''"
                >{{ $t("mylibrary.mylibrary.myinfo") }}</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      component: null,
      componentName: null,
      on: false,
      boardId: "",
      nav: "Bookmarks",
    };
  },
  methods: {
    loadComponent(type) {
      this.on = true;
      this.componentName = type;
      this.$store.commit("setPage", 1);
      this.$store.commit("setSearchWord", "");
      this.$store.commit("setComponentName", type);
      this.boardId = this.$store.getters.getBoardId;
    },
    changeNav(name) {
      this.nav = name;
    },
  },
  mounted() {
    console.log(this.$store.state.componentName);
    if (this.$store.state.componentName == "Bookmarks") {
      this.$store.commit("setComponentName", "Bookmarks");
      this.componentName = "Bookmarks";
      this.loadComponent("Bookmarks");
    } else {
      this.loadComponent(this.$store.state.componentName);
    }
  },
};
</script>

<style></style>
